import type { Mouvement } from '@mairistem/comptabilite';

import { FicheContainer, useFiche } from '@mairistem/fiche';
import type { ErrorField } from '@mairistem/liste';
import { findKey } from 'lodash';
import React from 'react';
import type BaseProfilEcritureMouvement from '../../../classes/mouvements/profilEcriture/Base/BaseProfilEcritureMouvement';
import { MOUVEMENT_BACK_ERROR } from '../../../errors/mouvements/mouvementErrors';
import checkMouvement from '../../../utils/mouvements/controls/checkMouvement';
import MouvementFicheBarConsumer from './MouvementFicheBarConsumer';
import MouvementFicheConsumer from './MouvementFicheConsumer';

const handleUrl = (method: string, { identifiant }) => {
	switch (method) {
		case 'get':
		case 'put':
			return `/api/finances/comptabilite/piecescomptables/mouvements/${identifiant}?withExercice=true&withLignes=true&withLigneDetail=true&withTiers=true&withBordereau=true`;
		case 'delete':
			return `/api/finances/comptabilite/piecescomptables/mouvements/${identifiant}`;
		default:
			return '/api/finances/comptabilite/piecescomptables/mouvements';
	}
};

const MouvementFiche = () => {
	const [mouvementService] = useFiche(handleUrl);
	const [isModalSemaphoreVisible, setIsModalSemaphoreVisible] =
		React.useState(false);
	const [selectedProfilEcriture, setSelectedProfilEcriture] =
		React.useState<BaseProfilEcritureMouvement>();

	const handleValidate = (mouvement: Mouvement): ErrorField[] =>
		checkMouvement(mouvement, selectedProfilEcriture);

	const handleApiError = (errors) => {
		if (errors?.status >= 500) {
			return {
				message: 'Une erreur technique est survenue',
			};
		}
		const responseErrors = errors?.response?.data;

		// Si l'une des erreurs a le code 'semaphore', afficher la modale
		if (responseErrors.some((err) => err?.code === 'semaphore')) {
			setIsModalSemaphoreVisible(true);
		}

		const resultErrors = responseErrors.map((error) => ({
			id: findKey(MOUVEMENT_BACK_ERROR, (value) => value.includes(error?.code)),
			message: error?.message?.[0],
		}));

		return resultErrors;
	};

	return (
		<FicheContainer
			type="piece"
			service={mouvementService}
			onValidate={handleValidate}
			onApiError={handleApiError}
		>
			{(props) => (
				<>
					<MouvementFicheBarConsumer {...props} />
					<MouvementFicheConsumer
						{...props}
						handleChangeModalSemaphoreVisible={setIsModalSemaphoreVisible}
						isModalSemaphoreVisible={isModalSemaphoreVisible}
						selectedProfilEcriture={selectedProfilEcriture}
						setSelectedProfilEcriture={setSelectedProfilEcriture}
					/>
				</>
			)}
		</FicheContainer>
	);
};

export default MouvementFiche;
